import { useState } from 'react';

type FaqItem = {
  q: string;
  a: string;
};

export default function FaqAccordion({ items, defaultOpen = 0 }: { items: FaqItem[]; defaultOpen?: number }) {
  const [openIndex, setOpenIndex] = useState<number | null>(defaultOpen);

  return (
    <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={item.q}>
            <button
              type="button"
              onClick={() => setOpenIndex(isOpen ? null : index)}
              aria-expanded={isOpen}
              className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors hover:bg-background-100 md:px-6"
            >
              <span className="flex items-start gap-3">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-xs font-bold text-secondary-800">
                  Q
                </span>
                <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">{item.q}</span>
              </span>
              <i
                className={`shrink-0 text-xl text-foreground-500 transition-transform ${
                  isOpen ? 'ri-subtract-line' : 'ri-add-line'
                }`}
              ></i>
            </button>
            {isOpen && (
              <div className="px-5 pb-6 md:px-6">
                <p className="flex items-start gap-3 text-sm leading-7 text-foreground-600">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-primary-100 text-xs font-bold text-primary-700">
                    A
                  </span>
                  <span>{item.a}</span>
                </p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}